import { request } from "../../../backend";

export async function distributeAgreementViaSms(agreementKey: string, recipient: string, isSignableViaSms?: boolean) {
  await request(`/agreement/${agreementKey}/distribute/sms`, 'post', {
    recipient,
    isSignableViaSms
  });
}